import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-cancel-seminar-dialog',
  templateUrl: './cancel-seminar-dialog.component.html',
  styleUrl: './cancel-seminar-dialog.component.scss',
  standalone: false,
})
export class CancelSeminarDialogComponent {
  public reason: string = '';
  public errorMessage: string = '';

  constructor(private dialogRef: DynamicDialogRef) {}

  public closeDialog(confirmed: boolean) {
    this.errorMessage = '';
    if (confirmed) {
      if (!this.reason) {
        this.errorMessage = 'Du musst einen Grund angeben.';
        return;
      }
      this.dialogRef.close({
        confirmed: true,
        reason: this.reason,
      });
    }
    this.dialogRef.close({
      confirmed: false,
      reason: this.reason,
    });
  }
}
